<template>
  <div class="fzxw">
      <!-- v-if="$route.query.id - 0 === i" -->
      <div class="xhImg" v-for="(item,i) in xhImg" :key="i" v-if="$route.query.id - 0 === i">
          <img :src="item.img1" alt="">
          <img :src="item.img2" alt="">
          <img :src="item.img3" alt="">
          <img :src="item.img4" alt="">
          <img :src="item.img5" alt="">
      </div>
  </div>
</template>

<script>
export default {
  name: 'fzxw',
   components: {
  },
  data () {
    return {
      xhImg: [
        {
          img1: require('../../static/img/gdym01.png'),
          img2: require('../../static/img/gdym02.png'),
          img3: require('../../static/img/gdym03.png'),
          img4: require('../../static/img/gdym04.png'),
          id: '0'
        },
        {
          img1: require('../../static/img/tf01.png'),
          img2: require('../../static/img/tf02.png'),
          img3: require('../../static/img/tf03.png'),
          img4: require('../../static/img/tf04.png'),
          id: '1'
        },
        {
          img1: require('../../static/img/xt01.png'),
          img2: require('../../static/img/xt02.png'),
          img3: require('../../static/img/xt03.png'),
          img4: require('../../static/img/xt04.png'),
          id: '2'
        },
        {
          img1: require('../../static/img/gy01.png'),
          img2: require('../../static/img/gy02.png'),
          img3: require('../../static/img/gy03.png'),
          img4: require('../../static/img/gy04.png'),
          id: '3'
        },
        {
          img1: require('../../static/img/cc01.png'),
          img2: require('../../static/img/cc02.png'),
          img3: require('../../static/img/cc03.png'),
          img4: require('../../static/img/cc04.png'),
          id: '4'
        },
        {
          img1: require('../../static/img/hx01.png'),
          img2: require('../../static/img/hx02.png'),
          img3: require('../../static/img/hx03.png'),
          img4: require('../../static/img/hx04.png'),
          id: '5'
        },
        {
          img1: require('../../static/img/jk01.png'),
          img2: require('../../static/img/jk02.png'),
          img3: require('../../static/img/jk03.png'),
          img4: require('../../static/img/jk04.png'),
          id: '6'
        },
        {
          img1: require('../../static/img/fx01.png'),
          img2: require('../../static/img/fx02.png'),
          img3: require('../../static/img/fx03.png'),
          img4: require('../../static/img/fx04.png'),
          id: '7'
        },
      ]
    }
  },
  methods: {
    skip (url) {
      location.href = url
    },
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
  mounted() {
      let id = this.$route.query.id
      if(this.isMobile()) {
        this.$router.push({path:'/fsproducts?id=', query: {id:id}})
        } else {
        this.$router.push({path:'/cpxq?page=3&id=', query: {id: id}})
        }
  }
}
</script>
<style lang="scss" scoped>
.fzxw{
  .xhImg{
    width: 100%;
    padding-bottom: .1rem;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Fsproducts.vue